<template>
      <v-dialog v-model="dialog" persistent max-width="800px">
         <v-form v-model="valid" ref="form" lazy-validation>
      <v-card>
        <v-toolbar dark color="primary elevation-1">
          <v-btn icon @click.native="close" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Add destination</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click.native="save">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field v-model="form.name" label="Name" required :rules="itemRules"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <g-input
                  :required="true"
                  ref="address_dest"
                  id="address_dest"
                  @change="setAddress"
                  @placechanged="setPlace"
                  :label="'Address'"
                  :clearable="true"
                  :delete="true"
                  :rules="itemRules"
                  :error="adress_notValid"
                ></g-input>
                <span v-if="adress_notValid" class="input-group__details error--text">Address is uncomplete, select a completed address.</span>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field v-model="form.tel" label="tel" required></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
      </v-card>
      </v-form>
    </v-dialog>
</template>

<script>
  import DestinationFormMixin from '@/mixins/destination-form';
  export default {
    mixins: [DestinationFormMixin],
    data () {
      return {
      }
    }
  }
</script>

